import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Download } from "lucide-react";

const totalCards = 57;
const cards = Array.from({ length: totalCards }, (_, i) => ({
  num: i + 1,
  src: `/individual-cards/card-${String(i + 1).padStart(2, "0")}.png`,
  label: i === 0 ? "Cover Card" : `Card ${i + 1}`,
}));

export default function CardDownloads() {
  useEffect(() => { document.title = "Card Downloads — Affirmation Card Deck | Mind Body Spirit HYGIENE™ Tools"; }, []);
  return (
    <div className="bg-white min-h-screen" style={{ fontFamily: "'Nunito', sans-serif" }}>
      <header className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur-xl border-b border-[#CCFBF1]">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-[#25a1c2] hover:text-[#068fa2] text-sm font-medium">
            &larr; Back to Shop
          </Link>
          <span className="font-bold text-gray-700 text-sm">57 Individual Cards — Right-click to Save</span>
          <Link to="/build-your-own" className="text-[#068fa2] hover:text-[#25a1c2] text-sm font-medium transition-colors" data-testid="carddownloads-nav-build-your-own">Build Your Own</Link>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-6 pt-24 pb-16">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-extrabold text-gray-900 mb-3">Individual Card Downloads</h1>
          <p className="text-gray-500">Right-click any card → "Save Image As" to download for Canva editing</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {cards.map((card) => (
            <a
              key={card.num}
              href={card.src}
              target="_blank"
              rel="noopener noreferrer"
              className="group block bg-gray-50 rounded-xl overflow-hidden border border-gray-200 hover:border-[#25a1c2] hover:shadow-lg transition-all"
            >
              <img
                src={card.src}
                alt={card.label}
                className="w-full aspect-[3/4] object-cover group-hover:scale-105 transition-transform"
              />
              <div className="p-2 text-center flex items-center justify-center gap-1">
                <Download className="w-3 h-3 text-gray-400" />
                <span className="text-xs text-gray-600 font-medium">{card.label}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
